import { render, staticRenderFns } from "./NewStudents.vue?vue&type=template&id=f5d12a1c&scoped=true&"
import script from "./NewStudents.vue?vue&type=script&lang=js&"
export * from "./NewStudents.vue?vue&type=script&lang=js&"
import style0 from "./NewStudents.vue?vue&type=style&index=0&id=f5d12a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d12a1c",
  null
  
)

export default component.exports